module.exports = __webpack_public_path__ + "static/media/Qr-Scanner-sound.53d97f3b.mp3";